export const IFRAME_MODAL_MAX_WIDTH = 720;
